import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { BonusPaymentDto } from '@/app/common/general-types/brief-application.dto';
import { BriefResponseDto } from '@/app/common/general-types/briefs.dto';
import { CreatorResponseDto } from '@/app/common/general-types/creators.dto';
import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { FormField, form, required } from '@angular/forms/signals';
import { BriefApplicationService } from '@/app/services/brief-application/brief-application.service';
import { ToastNotificationService } from '@/app/atoms/toast-notification/toast-notification.service';
import { AlertService } from '@/app/atoms/alert/alert.service';
import { WalletService } from '@/app/services/wallet/wallet.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ViewportOverlayDirective } from '../../../../common/directives/viewport-overlay/viewport-overlay.directive';

@Component({
  selector: 'vs-pay-bonus',
  imports: [FormField],
  hostDirectives: [ViewportOverlayDirective],
  templateUrl: './pay-bonus.html',
  styleUrl: './pay-bonus.css',
  host: {
    '(document:keydown.escape)': 'closeModal()'
  }
})
export class PayBonus implements OnInit {
  readonly close = output<void>();
  creator = input<CreatorResponseDto>();
  brief = input<BriefResponseDto>();
  briefApplicationId = input<string>();

  payingBonus = signal<boolean>(false);
  bonusPaid = signal<boolean>(false);

  focussedBrand = signal<any | undefined>(undefined);

  bonusModel = signal({
    amount: 0,
    currency: 'GBP',
  });

  bonusForm = form(this.bonusModel, (schemaPath) => {
    required(schemaPath.amount, { message: 'Amount is required' });
    required(schemaPath.currency, { message: 'Currency is required' });
  });

  private readonly currentUserService = inject(CurrentUserService);
  private readonly briefApplicationService = inject(BriefApplicationService);
  private readonly toastNotificationService = inject(ToastNotificationService);
  private readonly alertService = inject(AlertService);
  private readonly walletService = inject(WalletService);

  ngOnInit(): void {

    this.focussedBrand.set(this.currentUserService.focussedBrand);
    if (this.focussedBrand()) {
      this.bonusModel().currency = this.focussedBrand().currencyCode;
    } else {
      this.bonusModel().currency = 'GBP';
    }
  }

  payBonus() {
    console.log('👉 payBonus()');
    console.log('👉 bonusModel(): ', this.bonusModel());

    this.payingBonus.set(true);

    const amount = this.bonusModel().amount * 100;
    const bonus: BonusPaymentDto = {
      amount: amount,
    };
    this.briefApplicationService.payBonus(this.briefApplicationId()!, bonus).subscribe({
      next: async (paidBonus: any) => {
        console.log('🤢🤢🤢 Pay Bonus() - paidBonus: ', paidBonus);

        if (paidBonus.hasInsufficientFunds) {
          this.payingBonus.set(false);
          // this.walletService.showTopUpDrawer = true;

          // this._notificationService.sendMessage({ message: "Insufficient funds", type: NotificationType.error });
          await this.alertService.alert({
            title: 'Insufficient funds',
            message: 'You do not have enough funds to pay the bonus. Please top up your wallet to continue.',
            confirmText: 'Top Up',
            cancelText: 'Cancel',
            type: 'alert',
            icon: 'warning',
          });
        } else {
          // this.bonusPaid.set(true);

          // refresh wallet amounts
          this.walletService.getBalance(this.focussedBrand().id).subscribe({
            next: balanceRes => {
              console.log('balanceRes: ', balanceRes);
              this.payingBonus.set(false);
              this.bonusPaid.set(true);
            }, error: (err: HttpErrorResponse) => {
              console.error('Error re-fetching balances ', err);
              // this._notificationService.sendMessage({message: err.error.message, type: NotificationType.error});
              this.toastNotificationService.alert({
                title: 'Error re-fetching balances',
                message: err.error.message,
                type: 'error',
                icon: 'error'
              });
            }
          })
        }
      }, error: (error) => {
        console.error('👉 payBonus() error: ', error);
        this.payingBonus.set(false);
        void this.toastNotificationService.alert({
          title: 'Failed to send support request',
          message: 'Failed to send support request',
          type: 'error',
          icon: 'error'
        });
      }
    });

  }

  getCurrencySymbol(): string {
    if (this.focussedBrand() && this.focussedBrand().currencyCode) {
      if (this.focussedBrand().currencyCode.toUpperCase() === 'GBP') {
        return '£';
      } else {
        return '$';
      }
    }
    return this.focussedBrand()?.currencyCode ?? '£';
  }

  closeModal(): void {
    this.close.emit();
  }
}
